import styled from "styled-components";


interface RoundImageProps {
    blur : string
}
export const FilmStripImage = styled.img<RoundImageProps>`
  width: 90%; /* or any custom size */
  height: 100%;
  object-fit: contain;
  filter: blur(${s => s.blur})

`;

export const DetailImage = styled.img<RoundImageProps>`
  max-width: clamp(100px, 100vw, 1200px);
  max-height: 500px;
  object-fit: contain;

`;



export const ButtonImage = styled.img`
  width: 40px; /* or any custom size */
  height: 30px;
  object-fit: contain;
  horiz-align: center;
 
`;